import { useInstantSearch } from "react-instantsearch";
import styles from "../PLP-2.0/PlpFilter/plpFilter.module.scss";
import { useEffect } from "react";
import { sendSiteSearchEvent } from "@/helpers/psykheHelper";
import { getCookie } from "cookies-next";

const TotalCount = (props) => {
  // setting default values to the props in case not passed
  const {
    shouldRender = true,
    setTotalPages = () => { },
    isUsedForPagination = false,
    productsLengthPerPage = null,
    setTotalFetchedProducts = () => { },
    totalFetchedProducts = null,
    resetPagination = () => { }
  } = props

  const { results } = useInstantSearch();

  useEffect(() => {
    if (isUsedForPagination) {
      setTotalPages(Math.ceil(results.nbHits / productsLengthPerPage))
      setTotalFetchedProducts(results.nbHits)
      // used to reset the pagination params to start calculating from 1st page when results are changed
      if (totalFetchedProducts !== results.nbHits && totalFetchedProducts !== null) {
        resetPagination(1)
      }
    }
    // This block handles sending a site search analytics event
    if(window && window?.location?.pathname?.includes("search")  && window?.location?.search?.includes("query=") && results?.nbHits > 0) {
      let collectionName = window?.location?.href
      let query = window?.location?.search?.split("=")[1]
      let count = results?.nbHits
      let recoId = getCookie("recoId")
      const urlRouteTracking = JSON.parse(localStorage.getItem("psykhe-plp") || "{}");
      if (!urlRouteTracking[collectionName] && collectionName.includes("/search?query=")) {
        // sends track site search view event to psyhke  
        sendSiteSearchEvent(query, count, recoId)
        urlRouteTracking[collectionName] = true;
        localStorage.setItem("psykhe-plp", JSON.stringify(urlRouteTracking));
      }
    }

  }, [results])

  return (
    <div className="search-result-count-plp">
      <>
        {shouldRender ? (<div className={`x-small-sm x-small-md xx-small-xs`}>
          <span className={`ais-Stats-text`}> {results.nbHits} results</span>
        </div>) : (<></>)}
      </>
    </div>
  );
};

export default TotalCount;
